<template>
  <b-list-group class="" cols="3">
    <b-row class="p-2 border-top" v-for="file in files" :key="file._id">
      <b-col>{{file.deviceId}}</b-col>
      <b-col>{{file.fileName}}</b-col>
      <b-col>{{file.assignedToName}}</b-col>
    </b-row>
  </b-list-group>
</template>
<script>
export default{
    name: 'List',
    props: {
        files: Array,
        fileStatus: String
    },
    mounted(){
    },
    methods: {
        tag(file){
            this.$emit('tag-file',file);
        }
    }
}
</script>
<style>
.border-top{
  border-top: 1px solid #dceaea;
}
</style>
